export const TEST_ID = {
  COMPONENT: 'feedback-capture',
  HEADING: 'feedback-capture-heading',
  INITIAL_STEP: 'feedback-capture-initial-step',
  INITIAL_STEP_CTA_YES: 'feedback-capture-initial-step-cta-yes',
  INITIAL_STEP_CTA_NO: 'feedback-capture-initial-step-cta-no',
  COMPLETE_STEP: 'feedback-capture-complete-step'
};
